import { privileges } from "@lifepay/rc-ui-toolkit";

const { CONSTANTS: { ENSURE_TYPES, MANUAL_ENSURE_WAYS } } = privileges;

export const PRIVILEGE_KEYS = {
  CONTACT_NUMBER: "CONTACT_NUMBER",
  BACKUP_NUMBER: "BACKUP_NUMBER",
  STANDARD: "STANDARD",
  FULL: "FULL",
  EXTENDED: "EXTENDED",
};

export const LOCK_KEYS = {
  FINANCIAL_INFO: "Финансовая информация",
  CARD_ISSUING_STATUS: "Готовность и выдача карты",
  CLIENT_ISSUES: "Обращение и претензия",
  CONTACT_NUMBER_CHANGE: "Изменение контактного мобильного номера телефона",
  CLIENT_INFO_CHANGE:
    "Изменение паспортных данных, адреса, дополнительного номера телефона, адреса электронной почты",
  CARD_ACTIVATION: "Активация карты",
  CARD_BLOCK: "Блокировка карты",
  CARD_UNBLOCK: "Разблокировка карты",
  CARD_PIN_CHANGE: "Установка ПИН-кода",
  CARD_PIN_COUNTER_RESET: "Сброс попыток неверного ввода ПИН-кода",
  CARD_REISSUE: "Перевыпуск карты",
  CARD_LIMITS: "Изменение лимитов, транзакционных схем",
  CARD_3DS_CHANGE: "Подключение/Отключение 3DS",
  CARD_TRANSACTIONS_VIEW: "Запрос выписки/Справки по операциям",
  CARD_TRANSACTION_CANCEL: "Отмена неуспешной авторизации",
  CARD_MONITORING_WHITELIST:
    "Внесение карты в white list для системы мониторинга",
};

export const PRIVILEGES = {
  [PRIVILEGE_KEYS.CONTACT_NUMBER]: {
    label: "Звонок с контактного номера",
    hideDefaultControl: true,
    disableManualControl: true,
    requirements: [
      {
        ensure: ENSURE_TYPES.BOOLEAN_PROPS,
        options: {
          propKey: "isContactNumber",
          label: "Основной контактный номер",
        },
      },
    ],
  },
  [PRIVILEGE_KEYS.BACKUP_NUMBER]: {
    label: "Звонок с дополнительного номера",
    hideDefaultControl: true,
    disableManualControl: true,
    requirements: [
      {
        ensure: ENSURE_TYPES.BOOLEAN_PROPS,
        options: {
          propKey: "isBackupNumber",
          label: "Другой контактный номер",
        },
      },
    ],
  },
  [PRIVILEGE_KEYS.STANDARD]: {
    label: "Стандартная авторизация",
    revokes: [PRIVILEGE_KEYS.FULL, PRIVILEGE_KEYS.EXTENDED],
    requirements: [
      {
        type: ENSURE_TYPES.MANUAL,
        options: {
          way: MANUAL_ENSURE_WAYS.ASK_CLIENT,
          label: "Кодовое слово",
        },
      },
    ],
  },
  [PRIVILEGE_KEYS.FULL]: {
    label: "Полная авторизация",
    grants: [PRIVILEGE_KEYS.STANDARD],
    revokes: [PRIVILEGE_KEYS.EXTENDED],
    requirements: [
      {
        type: ENSURE_TYPES.EXTENDS,
        options: {
          key: PRIVILEGE_KEYS.STANDARD,
        },
      },
      {
        type: ENSURE_TYPES.MANUAL,
        options: {
          way: MANUAL_ENSURE_WAYS.ASK_CLIENT,
          label: "Серия и номер паспорта",
        },
      },
      {
        type: ENSURE_TYPES.MANUAL,
        options: {
          way: MANUAL_ENSURE_WAYS.ASK_CLIENT,
          label: "Адрес места регистрации",
        },
      },
    ],
  },
  [PRIVILEGE_KEYS.EXTENDED]: {
    label: "Расширенная авторизация",
    grants: [PRIVILEGE_KEYS.STANDARD, PRIVILEGE_KEYS.FULL],
    requirements: [
      {
        type: ENSURE_TYPES.EXTENDS,
        options: {
          key: PRIVILEGE_KEYS.FULL,
        },
      },
      {
        type: ENSURE_TYPES.MANUAL,
        options: {
          way: MANUAL_ENSURE_WAYS.ASK_CLIENT,
          label:
            "Дата последнего обращения в банк / Дата последней операции по карте",
        },
      },
      {
        type: ENSURE_TYPES.MANUAL,
        options: {
          way: MANUAL_ENSURE_WAYS.ASK_CLIENT,
          label: "Адрес электронной почты",
        },
      },
    ],
  },
};

export const LOCKS = {
  [LOCK_KEYS.FINANCIAL_INFO]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.FULL],
    ],
  },
  [LOCK_KEYS.CARD_ISSUING_STATUS]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.FULL],
    ],
  },
  [LOCK_KEYS.CLIENT_ISSUES]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.FULL],
    ],
  },
  [LOCK_KEYS.CONTACT_NUMBER_CHANGE]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
      [PRIVILEGE_KEYS.EXTENDED],
    ],
  },
  [LOCK_KEYS.CLIENT_INFO_CHANGE]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      // redundant rules
      // [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
      [PRIVILEGE_KEYS.FULL],
    ],
  },
  [LOCK_KEYS.CARD_ACTIVATION]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
    ],
  },
  [LOCK_KEYS.CARD_BLOCK]: {
    requirements: [
      // redundant rules
      // [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      // [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.STANDARD],
    ],
  },
  [LOCK_KEYS.CARD_UNBLOCK]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
    ],
  },
  [LOCK_KEYS.CARD_PIN_CHANGE]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
    ],
  },
  [LOCK_KEYS.CARD_PIN_COUNTER_RESET]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
    ],
  },
  [LOCK_KEYS.CARD_REISSUE]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
    ],
  },
  [LOCK_KEYS.CARD_LIMITS]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
      [PRIVILEGE_KEYS.EXTENDED],
    ],
  },
  [LOCK_KEYS.CARD_3DS_CHANGE]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
    ],
  },
  [LOCK_KEYS.CARD_TRANSACTIONS_VIEW]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
      [PRIVILEGE_KEYS.EXTENDED],
    ],
  },
  [LOCK_KEYS.CARD_TRANSACTION_CANCEL]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
      [PRIVILEGE_KEYS.EXTENDED],
    ],
  },
  [LOCK_KEYS.CARD_MONITORING_WHITELIST]: {
    requirements: [
      [PRIVILEGE_KEYS.CONTACT_NUMBER, PRIVILEGE_KEYS.STANDARD],
      [PRIVILEGE_KEYS.BACKUP_NUMBER, PRIVILEGE_KEYS.FULL],
      [PRIVILEGE_KEYS.EXTENDED],
    ],
  },
};



// WEBPACK FOOTER //
// ./src/config/privileges/client.js